import { render, staticRenderFns } from "./BerkleyFiles.vue?vue&type=template&id=5b0e1e3a"
import script from "./BerkleyFiles.vue?vue&type=script&lang=js"
export * from "./BerkleyFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports